import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnknown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 18,
	viewBox: "0 0 26 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 25,
			height: 17,
			fill: "#F4F4F4"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 25,
			height: 17,
			stroke: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.27 7.73C15.27 7.95 15.2433 8.14333 15.19 8.31C15.1367 8.47667 15.06 8.63 14.96 8.77C14.8667 8.91 14.75 9.04333 14.61 9.17C14.4767 9.29 14.3233 9.41667 14.15 9.55C14.0433 9.63667 13.9533 9.71333 13.88 9.78C13.8133 9.84667 13.76 9.91667 13.72 9.99C13.68 10.0567 13.65 10.13 13.63 10.21C13.6167 10.2833 13.61 10.3733 13.61 10.48V10.74H12.05V10.36C12.05 10.1867 12.0667 10.0333 12.1 9.9C12.1333 9.76 12.1833 9.63333 12.25 9.52C12.3167 9.40667 12.3967 9.29667 12.49 9.19C12.59 9.08333 12.7067 8.97333 12.84 8.86L13.17 8.55C13.2833 8.45 13.38 8.34667 13.46 8.24C13.54 8.12667 13.58 7.99333 13.58 7.84C13.58 7.62667 13.5133 7.45667 13.38 7.33C13.2533 7.20333 13.0767 7.14 12.85 7.14C12.57 7.14 12.36 7.23667 12.22 7.43C12.08 7.61667 12.0033 7.83 11.99 8.07L10.4 7.9C10.44 7.54 10.53 7.22333 10.67 6.95C10.8167 6.67667 11.0033 6.45 11.23 6.27C11.4567 6.09 11.7133 5.95667 12 5.87C12.2867 5.77667 12.59 5.73 12.91 5.73C13.21 5.73 13.5 5.77 13.78 5.85C14.0667 5.92333 14.32 6.04333 14.54 6.21C14.76 6.37 14.9367 6.57667 15.07 6.83C15.2033 7.08333 15.27 7.38333 15.27 7.73ZM13.81 12.15C13.81 12.4167 13.7167 12.6433 13.53 12.83C13.3433 13.01 13.1133 13.1 12.84 13.1C12.7067 13.1 12.58 13.0767 12.46 13.03C12.3467 12.9833 12.2433 12.9167 12.15 12.83C12.0633 12.7433 11.9933 12.6433 11.94 12.53C11.8867 12.4167 11.86 12.2933 11.86 12.16C11.86 12.0333 11.8833 11.9133 11.93 11.8C11.9833 11.68 12.0533 11.5767 12.14 11.49C12.2333 11.4033 12.34 11.3367 12.46 11.29C12.58 11.2367 12.7067 11.21 12.84 11.21C12.9733 11.21 13.0967 11.2367 13.21 11.29C13.33 11.3367 13.4333 11.4033 13.52 11.49C13.6133 11.57 13.6833 11.67 13.73 11.79C13.7833 11.9033 13.81 12.0233 13.81 12.15Z",
			fill: "#3D3D3D"
		})
	]
});
export default SvgUnknown;
